import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {timeOptions} from "../constants/time_options";
import {TransportLabels} from "../types/TransportLabels";
import {TravelTimeValues} from "../types/TravelTimeValues";

interface IHitMapSearchParams {
    regionName: string;
    travelType: TransportLabels;
    travelTime: TravelTimeValues;
}

export function hitTravelTime(params: IHitMapSearchParams) {
    const {regionName, travelType, travelTime} = params;

    const timeOptionLabel = timeOptions.find((option) => option.value === travelTime)?.label;

    hitGoogleTagManager({
        event: "travel_time",
        event_category: regionName,
        event_category2: travelType,
        event_category3: timeOptionLabel || "na"
    });
}
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {timeOptions} from "../constants/time_options";
import {TransportLabels} from "../types/TransportLabels";
import {TravelTimeValues} from "../types/TravelTimeValues";

interface IHitMapSearchParams {
    regionName: string;
    travelType: TransportLabels;
    travelTime: TravelTimeValues;
}

export function hitTravelTime(params: IHitMapSearchParams) {
    const {regionName, travelType, travelTime} = params;

    const timeOptionLabel = timeOptions.find((option) => option.value === travelTime)?.label;

    hitGoogleTagManager({
        event: "travel_time",
        event_category: regionName,
        event_category2: travelType,
        event_category3: timeOptionLabel || "na"
    });
}
